import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-education-document-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsEducationDocumentTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consEducationDocumentTypeEntity = useAppSelector(state => state.consEducationDocumentType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consEducationDocumentTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.detail.title">ConsEducationDocumentType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.code">Code</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.nameEn}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consEducationDocumentTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-education-document-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-education-document-type/${consEducationDocumentTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsEducationDocumentTypeDetail;
